// Enum instead of const because 2 reasons:
// 1) api possibly will be extended with other modes
// 2) ReviewAnalysisModeEnum is easier to use as type instead of 'typeof REVIEW_ANALYSIS_MODE'
export enum ReviewsAnalysisModeEnum {
    competitors = 'competitors',
}
